import { computed } from "vue";
import { useAuthState, refreshUserProfile } from "@/services/authService";
import {
  canRequestFeedback as evaluateFeedbackAccess,
  canViewAllPrompts as evaluatePromptAccess,
  getFeedbackAccessMessage,
  isProUser as evaluateIsProUser,
  normalizeSubscriptionProfile,
  remainingFreeFeedback as evaluateRemainingFreeFeedback
} from "@/services/subscriptionAccess";

export function useSubscriptionAccess() {
  const { user, profile, isAuthenticated } = useAuthState();

  const normalizedProfile = computed(() =>
    normalizeSubscriptionProfile(profile.value)
  );

  const feedbackAccessState = computed(() =>
    evaluateFeedbackAccess({
      isAuthenticated: isAuthenticated.value,
      profile: profile.value
    })
  );

  return {
    user,
    profile,
    isAuthenticated,
    normalizedProfile,
    canViewAllPrompts: computed(() =>
      evaluatePromptAccess({
        isAuthenticated: isAuthenticated.value,
        profile: profile.value
      })
    ),
    canRequestFeedback: computed(() => feedbackAccessState.value.allowed),
    feedbackAccessState,
    remainingFreeFeedback: computed(() =>
      evaluateRemainingFreeFeedback(profile.value)
    ),
    isProUser: computed(() => evaluateIsProUser(profile.value)),
    feedbackStatusMessage: computed(() =>
      getFeedbackAccessMessage({
        isAuthenticated: isAuthenticated.value,
        profile: profile.value
      })
    ),
    refreshSubscriptionProfile: refreshUserProfile
  };
}